import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUserAttributes } from "lib/store/services/auth/selectors";
import { Button } from "./WhatsNewButton.styled";

export const WhatsNewButton = () => {
  const userAttributes = useSelector(selectUserAttributes);

  useEffect(() => {
    const win = window as Window & {
      Featurebase?: {
        (command: string, ...args: unknown[]): void;
        q?: unknown[];
      };
    };

    // Load Featurebase SDK script if not already loaded
    if (!document.getElementById("featurebase-sdk")) {
      const script = document.createElement("script");
      script.src = "https://do.featurebase.app/js/sdk.js";
      script.id = "featurebase-sdk";
      document.head.appendChild(script);
    }

    // Initialize Featurebase
    if (typeof win.Featurebase !== "function") {
      win.Featurebase = function () {
        (win.Featurebase!.q = win.Featurebase!.q || []).push(arguments);
      };
    }

    // Initialize changelog widget
    win.Featurebase("init_changelog_widget", {
      organization: "brinkcommerce",
      dropdown: {
        enabled: true,
        placement: "right",
      },
      popup: {
        enabled: true,
        usersName: userAttributes?.given_name || "",
        autoOpenForNewUpdates: true,
      },
      theme: "light",
      locale: "en",
    });
  }, [userAttributes]);

  return (
    <Button data-featurebase-changelog>
      What&apos;s New <span id="fb-update-badge"></span>
    </Button>
  );
};
